module.exports = __webpack_public_path__ + "static/media/Schneegrenzeunten.a372ca1a.svg";